var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CustomElement, P, PCSS, Utils } from '@pacem/pacem-core';
import { PacemFxElement } from './types';
//namespace Pacem.Components.Fx {
const CSS_CLASS = PCSS + '-fx-list';
let PacemFxListElement = class PacemFxListElement extends PacemFxElement {
    constructor() {
        super(...arguments);
        this._observed = (items) => {
            const children = Array.from(this.target.children);
            for (let item of items) {
                item.removedNodes.forEach(n => {
                    if (n instanceof Element) {
                        this.dispatchEvent(new CustomEvent('itemremoved', { detail: n }));
                    }
                });
                item.addedNodes.forEach((n, j) => {
                    if (n instanceof Element) {
                        this.dispatchEvent(new CustomEvent('itemadded', { detail: { item: n, index: children.indexOf(n) } }));
                    }
                });
            }
        };
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        if (!Utils.isNull(this.target)) {
            this._setup();
        }
    }
    disconnectedCallback() {
        if (!Utils.isNull(this._observer)) {
            this._observer.disconnect();
        }
        super.disconnectedCallback();
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (name === 'target') {
            if (old) {
                this._reset(old);
            }
            else {
                this._setup();
            }
        }
    }
    _reset(el) {
        Utils.removeClass(el, CSS_CLASS);
        this._observer.disconnect();
    }
    _setup() {
        const target = this.target;
        Utils.addClass(target, CSS_CLASS);
        const obs = this._observer = new MutationObserver(this._observed);
        obs.observe(target, { childList: true });
    }
};
PacemFxListElement = __decorate([
    CustomElement({
        tagName: P + '-fx-list'
    })
], PacemFxListElement);
export { PacemFxListElement };
